import React, { useState } from 'react';

// BOOTSTRAP COMPONENTS
import clsx from 'clsx';
import Collapse from 'react-bootstrap/Collapse';

// GLOBAL COMPONENTS
import Sprite from 'core/tools/Sprite';
import Title from 'parts/title/Title';

// STYLE
import styles from './collapse.module.scss';

// MAIN COMPONENT
const SearchCollapse = ({ title, total, children }) => {
  // STATE
  const [open, setOpen] = useState(false);

  // RENDER
  return total === undefined ? null : (
    <div className="mb-3">
      <Title
        className={clsx('mb-3 px-3 py-2 bg-gray-000 border', styles.toggle)}
        title={
          <div className="d-flex align-items-center">
            <div className="me-auto">
              {title}: {total}
            </div>
            <Sprite use={open ? 'chevron-up' : 'chevron-down'} className={clsx('text-primary', styles.icon)} />
          </div>
        }
        onClick={() => setOpen(!open)}
      />
      <Collapse in={open}>
        <div className="mb-5">{children}</div>
      </Collapse>
    </div>
  );
};

// EXPORT
export default SearchCollapse;
